import React from "react";
import { FaUser } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import styles from "../NewIPDPatientAdmission.module.css";

const PatientDetails = ({ formData }) => {
  const { t } = useTranslation();
  const p = formData.patientId || {};
  const fullName = [p.firstName, p.middleName, p.lastName].filter(Boolean).join(" ");

  const calculateAge = (dob) => {
    if (!dob) return "-";
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age >= 0 ? age : 0;
  };

  return (
    <div className={styles.leftPanel}>
      {/* Patient Photo */}
      <div className={styles.photo}>
        <FaUser size={80} color="#6b7280" />
      </div>

      {/* Name & ID */}
      <div className={styles.nameId}>
        <h2>{fullName || "-"}</h2>
        <p>{t("Patient ID")}: {p.patientId || "-"}</p>
      </div>

      {/* Patient Information */}
      <div className={styles.patientInfo}>
        {!!formData.ipdAdmissionId && (
          <div className={styles.fieldRow}>
            <label>{t("IPD ID")}:</label>
            <input type="text" value={formData.ipdAdmissionId} disabled />
          </div>
        )}
        <div className={styles.fieldRow}>
          <label>{t("Age")}:</label>
          <input type="text" value={p.age || calculateAge(p.dob)} disabled />
        </div>
        <div className={styles.fieldRow}>
          <label>{t("DOB")}:</label>
          <input type="text" value={p.dob ? p.dob.substring(0, 10) : "-"} disabled />
        </div>
        <div className={styles.fieldRow}>
          <label>{t("Gender")}:</label>
          <input type="text" value={p.gender || "-"} disabled />
        </div>
        <div className={styles.fieldRow}>
          <label>{t("Mobile")}:</label>
          <input type="text" value={p.mobile || "-"} disabled />
        </div>
        <div className={styles.fieldRow}>
          <label>{t("Address")}:</label>
          <input type="text" value={p.address || "-"} disabled />
        </div>
        <div className={styles.fieldRow}>
          <label>{t("Registration No")}:</label>
          <input type="text" value={p.registrationNo || "-"} disabled />
        </div>
      </div>
    </div>
  );
};

export default PatientDetails;
